var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import BasicArcheivesService from '../../../api/BasicArcheivesService';
import CommonService from '../../../api/CommonService';
import CategoryService from '../../../api/CategoryService';
import DistributionLeftTree from './DistributionLeftTree';
import AddGoodTable from './AddGoodTable.vue';
import _ from 'lodash';
var EActiveType;
(function (EActiveType) {
    EActiveType["UN_SELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var DistriDialog = (function (_super) {
    __extends(DistriDialog, _super);
    function DistriDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.treeData = [];
        _this.tableData = [];
        _this.total = 0;
        _this.curGoodNode = [];
        _this.activeName = '0';
        _this.selectRows = [];
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.formData = {};
        return _this;
    }
    DistriDialog.prototype.created = function () {
        this.service = BasicArcheivesService.getInstance();
        this.commonService = CommonService.getInstance();
        this.categoryService = CategoryService.getInstance();
        this.getTreeCategoryData();
    };
    DistriDialog.prototype.mounted = function () {
    };
    DistriDialog.prototype.getStockinitGoodslist = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var params = {
            keyword: this.formData.keyword,
            goods_type_id: this.curGoodNode.goods_type_id,
            supplier_upper_id: this.supplier_upper_id
        };
        this.service.getStockinitGoodslist(Object.assign({}, params, pager)).then(function (res) {
            if (res.data.success) {
                _this.tableData = res.data.data;
                _this.unSelectList = res.data.data;
                _this.total = res.data.total;
                _this.setSelected(true);
            }
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    DistriDialog.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        if (!this.canFreshTable)
            return;
        this.canFreshTable = false;
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), 'goods_format_id');
        var isUnselectAll = !currentSelectRows.length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, function (good) { return good.goods_format_id === currentRow.goods_format_id; })) {
            _.remove(this.selectedList, function (good) { return good.goods_format_id === currentRow.goods_format_id; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.SELECTED) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (good) {
                _.remove(_this.selectedList, function (item) { return item.goods_format_id === good.goods_format_id; });
            });
        }
        this.setSelected(this.activeName === EActiveType.SELECTED);
        setTimeout(function () {
            _this.canFreshTable = true;
        });
    };
    DistriDialog.prototype.handleClick = function (tab, event) {
        if (tab.name == "second") {
            this.setSelected();
        }
    };
    DistriDialog.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid.$refs.table;
        if (isUnSelFresh) {
            gridTable.clearSelection();
        }
        if (!this.selectedList.length) {
            this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.selectedList.forEach(function (good, index) {
                _this.$nextTick(function () {
                    _this.$refs.alreadyGrid.$refs.table.toggleRowSelection(good, true);
                });
                if (isUnSelFresh) {
                    var item_1 = _.find(_this.unSelectList, function (current) { return current.goods_format_id === good.goods_format_id; });
                    _this.$nextTick(function () {
                        gridTable.toggleRowSelection(item_1, true);
                    });
                }
            });
        }
    };
    DistriDialog.prototype.getTreeCategoryData = function () {
        var _this = this;
        this.categoryService.getCategoryTree().then(function (res) {
            _this.treeData = res.data.data;
        });
    };
    DistriDialog.prototype.search = function () {
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.getStockinitGoodslist();
    };
    DistriDialog.prototype.close = function () {
        this.$closeDialog();
    };
    DistriDialog.prototype.save = function () {
        this.$closeDialog();
        var selectRowIds = this.selectedList.map(function (item) {
            return item.goods_format_id;
        });
        this.$emit('save:ok', selectRowIds);
    };
    DistriDialog.prototype.nodeClick = function (node) {
        this.curGoodNode = node || null;
        this.getStockinitGoodslist();
    };
    DistriDialog.prototype.pageChange = function (pager) {
        this.getStockinitGoodslist(pager);
        this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
    };
    DistriDialog = __decorate([
        Component({
            components: {
                'left-tree': DistributionLeftTree,
                'add-good-table': AddGoodTable
            }
        })
    ], DistriDialog);
    return DistriDialog;
}(VueDialog));
export default DistriDialog;
